import React from 'react'
import { observer } from "mobx-react";
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import { Tooltip, TableCell, TableRow, Typography } from '@material-ui/core';
import { ActionDto, ReviewEmployeeAccountDto } from 'src/stores/models/qarFormModels';
import { QARFormCommentInput } from './comment';
import { QARFormActionSelect } from './action';
import MaterialTable from 'material-table';
import {QARFormAccountBulkReview} from "./accountBulkReview";
import QARFormHelper from './helper';


export const QARFormAccounts = observer(({ accounts, accountsChanges }: { accounts: ReviewEmployeeAccountDto[], accountsChanges: ReviewEmployeeAccountDto[] }) => {
    const renderTooltipMessage = (tooltipMessage: string) => {
        return <Typography component="h2" align='center'>{tooltipMessage}</Typography>
    }

    const renderEmployeeChameleonAdministratorIndicator = (employeeAccount: ReviewEmployeeAccountDto) => {
        if (employeeAccount.isChameleonAdmin) {
            return (
                <Tooltip title={renderTooltipMessage("The user is a Chameleon administrator in this account")} placement='top' arrow>
                    <SettingsApplicationsIcon fontSize="large"></SettingsApplicationsIcon>
                </Tooltip>
            );
        }
    }

    const renderAuxiliaryRow = (employeeAccount: ReviewEmployeeAccountDto, action: ActionDto, actionChanges: ActionDto) => {
        return <QARFormCommentInput employeeAccount={employeeAccount} action={action} actionChanges={actionChanges}></QARFormCommentInput>;
    }

    const renderEmployeeAccountRow = (employeeAccount: ReviewEmployeeAccountDto, action: ActionDto, actionChanges: ActionDto) => {
        
        return (
            <>
                <TableRow>
                    <TableCell width="5%" className='accountActions'>
                        <QARFormAccountBulkReview action={action} actionChanges={actionChanges}></QARFormAccountBulkReview>
                    </TableCell>
                    <TableCell width="15%">
                        {QARFormHelper.renderPermissionGroups(employeeAccount)}
                    </TableCell>
                    <TableCell width="15%">
                        {employeeAccount.systemName}
                    </TableCell>
                    <TableCell width="15%">
                        {employeeAccount.displayName}
                    </TableCell>
                    <TableCell width="25%" align="left">
                        {QARFormHelper.renderRole(employeeAccount.roles)}
                    </TableCell>
                    <TableCell width="15%" className='accountActions'>
                        <QARFormActionSelect action={action} actionChanges={actionChanges}></QARFormActionSelect>
                    </TableCell>
                    <TableCell align="center" width="10%">
                        {renderEmployeeChameleonAdministratorIndicator(employeeAccount)}
                    </TableCell>
                </TableRow>
            </>
        );
    }

    return (
        <MaterialTable
            options={{
                filtering: false,
                grouping: false,
                draggable: false,
                paging: false,
                search: false,
                showTitle: false,
                toolbar: false,
                header: false
                // rowStyle: rowData => ({
                //     backgroundColor: rowData.isChameleonAdmin ? '#EEE' : '#FFF'
                // })
            }}
            columns={[
                { title: 'Username', field: 'username', defaultSort: 'asc' },
                { title: 'System', field: 'systemName' },
                { title: 'Account', field: 'displayName' },
                { title: 'Role', field: 'role' },
                { title: 'Action', field: 'action', customSort: (a, b) => a.action.name - b.action.name },
                { title: '', field: 'indicators', sorting: false }
            ]}
            data={accounts}
            components={{
                Row: ({ data }: { data: ReviewEmployeeAccountDto }) => {

                    const employeeAccount = data;
                    const action = accounts.find(x => x.employeeReviewId === employeeAccount.employeeReviewId)!.action;
                    const actionChanges = accountsChanges.find(x => x.employeeReviewId === employeeAccount.employeeReviewId)!.action;

                    return (
                        <>
                            {renderEmployeeAccountRow(employeeAccount, action, actionChanges)}
                            {renderAuxiliaryRow(employeeAccount, action, actionChanges)}
                        </>
                    )
                },
            }}
        />
    );
});